import * as React from "react";
import { Component } from "react";
import MainLayout from "../../layouts/MainLayout";
import Table from "../../components/Table";
import { __, getURLParam, mapStateToProps, setTableParams } from "../../core/utils";
import {createSidebar, createSuperadminSidebar} from "../../redux/actions/general/sidebar";
import { listActiveModules } from "../../redux/actions/general/active_modules";
import Tooltip from "../../components/Tooltip";
import * as _ from "lodash";
import { setPlusActions } from "../../redux/actions/general/plus";
import DeleteIcon from "../../assets/images/delete-15x15.svg";
import { hideAlertbox, showAlertbox } from "../../redux/actions/general/alertbox";
import { setNotification } from "../../redux/actions/general/notification";
import PaperSizesFlyout from "../../flyouts/superadmin/paper_sizes/PaperSizesFlyout";
import {
	deletePaperSizes,
	listPaperSizes,
	readPaperSize,
} from "../../redux/actions/table/superadmin/paper_sizes";
import { listLocalization } from "../../redux/actions/localization";

@mapStateToProps(state => ({
	superadmin: state.auth.superadmin,
	table: state.table["superadmin_paper_sizes"],
	auth: state.auth,
}))
class PaperSizes extends Component {
	constructor(props) {
		super(props);

		this.state = {
			preview: null,
		};
	}

	componentDidMount() {
		listActiveModules();
		createSuperadminSidebar(); //don't forget to add new routes in sidebar.js

		const { superadmin } = this.props;

		superadmin.add_paper_size && setPlusActions([{
			title: "Add paper size",
			onClick: () => setTableParams('superadmin_paper_sizes', {
				add_paper_size_wizard: true
			})
		}]);
	}

	componentDidUpdate(prevProps) {
		if (this.props.table.clicked_row && this.props.table.clicked_row !== prevProps.table.clicked_row) {
			if (!prevProps.table.clicked_row) {
				this.setState({ preview: undefined });
			}

			readPaperSize(this.props.table.clicked_row).then(({ response }) => {
				this.setState({ preview: response.data });
			});
		}
	}

	render() {
		const { superadmin } = this.props;

		let columns = [
			{
				key: "name",
				name: "Name",
				required: true,
				value: name => (
					<Tooltip text={name}>{name}</Tooltip>
				)
			},
			{
				key: "width",
				name: "Width",
				width: 100,
				value: width => (
					<Tooltip text={width}>{width}</Tooltip>
				)
			},
			{
				key: "height",
				name: "Height",
				width: 100,
				value: height => (
					<Tooltip text={height}>{height}</Tooltip>
				)
			}
		];

		const singleActions = (paper_size_id) => {
			return [
				<Tooltip text="Delete selected paper size" key={_.uniqueId()}>
					<DeleteIcon
						onClick={e => {
							e.stopPropagation();

							showAlertbox({
								color: "red",
								title: __('general.alert.are-you-sure'),
								description: "Do you really want to delete the selected paper size?\nThis process cannot be undone.",
								buttons: [
									{
										color: 'lightGray',
										text: __('general.alert.no-close'),
										onClick: 'close'
									},
									{
										color: 'gray',
										text: __('general.alert.yes-delete'),
										onClick: () => {
											deletePaperSizes([paper_size_id]).then(() => {
												hideAlertbox();

												setNotification("The selected paper size has been deleted.");
												listPaperSizes();

												listLocalization();

												setTableParams('superadmin_paper_sizes', {
													actioned_row: undefined
												});
											});
										},
									}
								]
							})
						}}
					/>
				</Tooltip>
			];
		};

		const groupActions = (paper_sizes_ids) => [
			<Tooltip text="Delete selected paper sizes" key={_.uniqueId()}>
				<DeleteIcon
					onClick={e => {
						e.stopPropagation();

						showAlertbox({
							color: "red",
							title: __('general.alert.are-you-sure'),
							description: "Do you really want to delete these paper sizes?\nThis process cannot be undone.",
							buttons: [
								{
									color: 'lightGray',
									text: __('general.alert.no-close'),
									onClick: 'close'
								},
								{
									color: 'gray',
									text: __('general.alert.yes-delete'),
									onClick: () => {
										deletePaperSizes(paper_sizes_ids).then(() => {
											hideAlertbox();

											setNotification("The selected paper sizes have been deleted.");
											listPaperSizes();

											listLocalization();

											setTableParams('superadmin_paper_sizes', {
												selected_rows: []
											});
										});
									},
								}
							]
						})
					}}
				/>
			</Tooltip>
		];

		const preview = (
			<PaperSizesFlyout
				data={this.state.preview}
				readAction={paper_size_id => {
					return new Promise(resolve => {
						readPaperSize(getURLParam('id') || paper_size_id).then(({ response }) => {
							this.setState({ preview: response.data });

							resolve(response);
						});
					});
				}}
			/>
		);

		return (
			<Table
				listAction={listPaperSizes}
				name="superadmin_paper_sizes"
				groupActions={superadmin.delete_paper_size && groupActions}
				singleActions={superadmin.delete_paper_size && singleActions}
				title={__("modules.submodules.title.paper-sizes")}
				preview={this.state.preview ? preview : []}
				columns={columns}
			/>
		);
	}
}

export default PaperSizes;
